import C2 from "../../assets/CSS.png";
import C5 from "../../assets/gulp.png";
import C1 from "../../assets/html.png";
import C3 from "../../assets/JS.png";
import C6 from "../../assets/pug.png";
import C4 from "../../assets/react.png";
import C7 from "../../assets/sass.png";
import C8 from "../../assets/django.png";
import C9 from "../../assets/API.png";
import C10 from "../../assets/PostgreSQL.png";
import C11 from "../../assets/mysql.png";
import C12 from "../../assets/sqlserver.png";

const Data = [
  {
    id: 1,
    img: C1,
    title: "Using HTML",
    skillpres: "100%",
  },
  {
    id: 2,
    img: C2,
    title: "Using CSS",
    skillpres: "100%",
  },
  {
    id: 3,
    img: C3,
    title: "Using JS",
    skillpres: "80%",
  },
  {
    id: 4,
    img: C4,
    title: "Using React",
    skillpres: "75%",
  },
  {
    id: 5,
    img: C5,
    title: "Using GulpJS",
    skillpres: "75%",
  },
  {
    id: 6,
    img: C6,
    title: "Using PugJs",
    skillpres: "75%",
  },
  {
    id: 7,
    img: C7,
    title: "Using SASS",
    skillpres: "75%",
  },

  {
    id: 8,
    img: C8,
    title: "Using Django",
    skillpres: "40%",
  },
  {
    id: 9,
    img: C9,
    title: "Using API",
    skillpres: "25%",
  },
  {
    id: 10,
    img: C10,
    title: "Using PostgreSQL",
    skillpres: "75%",
  },
  {
    id: 11,
    img: C11,
    title: "Using Mysql",
    skillpres: "75%",
  },
  {
    id: 12,
    img: C12,
    title: "Using Sql Server",
    skillpres: "75%",
  },
];
export default Data;
